<script>

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

import axios from 'axios'

export default {
  page: {
    title: '360MDR Exclusions - IPv4',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader
  },
  data () {
    return {
      tableBusy: true,
      tableData: [],
      ipAddress: '',
      ipMask: '32',
      ipMasks: ['32', '31', '30', '29', '28', '27', '26', '25', '24', '16', '8'],
      fields: [
        { key: 'address', field: 'ipAddress', label: 'IP', control: 'SearchInput', sortable: false, visible: false },
        { key: 'action', label: 'Action', sortable: false, visible: true }
      ],
      title: 'IPv4 Exclusions',
      category: 'List',
      items: [
        {
          text: 'Home',
          href: '/'
        },
        {
          text: 'IPv4 Exclusions',
          active: true
        }
      ],
      appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev')
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData (src = '') {
      let that = this
      that.isBusy = true
      let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
      const url = `${baseURL}/auto/exclusion/ip/list`

      axios.get(url)
        .then((response) => {
          that.tableData = response.data.data
          that.tableBusy = false
        })
        .catch(function () {

        })
    },
    showIPToExclusionListModal () {
      this.$refs['modal-add-exclusion-ip'].show()
    },
    validateIPv4 () {
      const ipv4Pattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
      this.error = !ipv4Pattern.test(this.ipAddress)
    },
    addIPToExclusion () {
      this.$refs['modal-add-exclusion-ip'].hide()
      const address = this.ipAddress + '/' + this.ipMask
      const data = {
        address: address
      }
      let baseURL = this.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
      const url = `${baseURL}/auto/exclusion/ip/add`
      axios.post(url, data)
        .then(response => {
          console.log('Response:', response.data)
          this.loadData()
        })
        .catch(error => {
          console.error('There was an error!', error)
        })
      console.log('address', address)
    },
    removeIPFromExclusionList (address) {
      let confirmDelete = confirm("Are you sure you want to delete this IP?")
      if (!confirmDelete) {
        return
      }
      const data = {
        address: address
      }
      let baseURL = this.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
      const url = `${baseURL}/auto/exclusion/ip/remove`
      axios.post(url, data)
        .then(response => {
          console.log('Response:', response.data)
          this.loadData()
        })
        .catch(error => {
          console.error('There was an error!', error)
        })
    },
    closeAddIPToExclusion () {
      this.$refs['modal-add-exclusion-ip'].hide()
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader
      :title="title"
      :items="items"
    />
    <div
      class="container"
      style="max-width: 1420px !important;"
    >
      <div class="row page-title align-items-center" />
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="text-md-right">
              <b-button
                class="btn btn-primary mb-3 ml-auto"
                @click="showIPToExclusionListModal"
              >
                Add IP to Exclusion List
              </b-button>
            </div>
            <div class="table-responsive mb-0">
              <b-table
                :items="tableData"
                :fields="fields"
                :busy="tableBusy"
                responsive="sm"
                :per-page="0"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :total-rows="totalRows"
                :pagination-options="{
                  enabled: true,
                }"
              >
                <template v-slot:cell(action)="data">
                  <b-dropdown
                    right
                    variant="white"
                    class="align-self-center"
                    toggle-class="p-0"
                  >
                    <template v-slot:button-content>
                      <feather
                        type="chevron-down"
                        class="align-middle"
                        style="height:12px !important;width:20px !important;"
                      />
                    </template>
                    <b-dropdown-item
                      class="notify-item"
                      @click="removeIPFromExclusionList(data.item.address)"
                    >
                      <feather
                        type="minus-circle"
                        class="icon-dual icon-xs mr-2 align-middle"
                      />
                      <span style="padding-top: 5px;">Remove IP</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
                <template v-slot:table-busy>
                  <div class="text-center">
                    <br><br>
                    <b-spinner class="align-middle" />
                    <strong>&nbsp;&nbsp;Loading...</strong>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
      <b-modal
        id=""
        ref="modal-add-exclusion-ip"
        size="xs"
        title="Add IP to Exclusion List"
        :ok-only="false"
        :centered="true"
        :no-fade="true"
        @ok="handleOk"
      >
        <div class="row">
          <div class="col-md-6">
            <div class="form-group mb-1">
              <label>IP</label>
              <input
                id="address"
                v-model="ipAddress"
                type="text"
                class="form-control"
                placeholder="IPv4"
                @input="validateIPv4"
              >
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group mb-2">
              <label>Mask</label>
              <b-form-select
                v-model="ipMask"
                :options="ipMasks"
                placeholder="IP Mask"
              />
            </div>
          </div>
        </div>
        <template v-slot:modal-footer>
          <b-button
            variant="secondary"
            @click="closeAddIPToExclusion"
          >
            Cancel
          </b-button>
          <b-button
            variant="primary"
            :disabled="error"
            @click="addIPToExclusion"
          >
            OK
          </b-button>
        </template>
      </b-modal>
    </div>
    </div>
  </Layout>
</template>

<style>
.even-row {
  background-color: #f9f9f9;
}

.odd-row {
  background-color: #ffffff;
}
</style>
